import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';

//Constants
import { urlOVS, apiUrls, urlOVSAndroid } from './../../constants/constants';

//Service
import { Observable } from 'rxjs/Observable';
import { Platform } from 'ionic-angular/platform/platform';

@Injectable()
export class EndpointServiceProvider {

    private platformString = '';
    private idToken: string = '';

    private urlRootAPI: string = urlOVS;

    constructor(
        private http: Http,
        private platform: Platform
    ) {

        this.platformString = this.platform.platforms().toLocaleString();

        if (this.platform.is('core') || this.platform.is('mobileweb')) {

        } else {
            if (this.platform.is('android') || this.platform.is('ios'))
                this.urlRootAPI = urlOVSAndroid;
        }

        //console.log("platformString -> " + this.platformString);
    }

    /*
    * carica token firebase dopo auteticazione
    */
    setToken(idToken: string): void {
        //console.log(idToken);
        this.idToken = idToken;
    }

    /*
    * dopo aver seguito il login verifica l'account da /users/user_list
    */
    login(device_id: string): Observable<any> { //'/api/login'

        let body = {
            "device_id": device_id
        }
        return this.sentRequest(this.urlRootAPI + apiUrls.login, body);
    }

    /*
    * conferma la settimana per l'utente passato
    */
    confirm_week(endpoint: string): Observable<string> { //'/api/confirm_week'

        /*let bodyEs = {
            "endpoint": "years/2017/51/ggiorgianni@demogoreplyio"
        };*/

        let body = {
            "endpoint": endpoint
        }

        return this.sentRequest(this.urlRootAPI + apiUrls.confirm_week, body);
    }

    /*
    * Blocca/sblocca la settimana per l'utente passato
    */
    week_lock(endpoint: string): Observable<string> { //'/api/week_unlock'

        /*let BodyEs = {
            "endpoint": "years/2017/51/ggiorgianni@demogoreplyit"
        };*/

        let body = {
            "endpoint": endpoint
        }

        return this.sentRequest(this.urlRootAPI + apiUrls.week_lock, body);
    }

    /*
    * funzione autocompletamento per i luoghi
    */
    autocompletion_loc(query: string, language: string): Observable<string> { //'/api/autocompletion_loc'

        /*let BodyEs = {
            "query": "Caru"
        };*/

        let body = {
            "query": query,
            "language": language
        }

        return this.sentRequest(this.urlRootAPI + apiUrls.autocompletion_loc, body);
    }

    /*
    * funzione autocompletamento per la ricerca
    */
    search_autocomplete(query: string, date: string): Observable<string> { //'/api/autocompletion_loc'

        /*let BodyEs = {
            "query": "Caru"
        };*/

        let body = {
            "query": query,
            "date": date
        }

        return this.sentRequest(this.urlRootAPI + apiUrls.search_autocomplete, body);
    }

    /*
    * funzione autocompletamento per la ricerca generica
    */
    search_generic(query: string, date: string): Observable<string> { //'/api/autocompletion_loc'

        /*let BodyEs = {
            "query": "Caru"
        };*/

        let body = {
            "query": query,
            "date": date
        }

        return this.sentRequest(this.urlRootAPI + apiUrls.search_generic, body);
    }

    /*
    * funzione autocompletamento per la ricerca
    */
    save_slots(week_id: string, week: any, places?: any): Observable<string> { //'/api/autocompletion_loc'

        let body = {
            places: {}
        };

        body[week_id] = week;

        if (places) {
            body.places = places;
        }

        return this.sentRequest(this.urlRootAPI + apiUrls.save_slots, body);
    }

    /**
      * Metodo per inserire il token nell'header e far le richieste get\post
      */
    private setHeaders() {

        let headers: Headers = new Headers();
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers.append('Client-Platform', this.platformString);
        headers.append('Authorization', this.idToken);

        return headers;
    }

    private sentRequest(url: string, body: any, idToken?: string): Observable<any> {

        let opts = new RequestOptions();
        opts.headers = this.setHeaders();

        //console.log(url);

        return this.http.post(url, body, opts)
            .map(res => res.json());

    }

}


// WEBPACK FOOTER //
// ./src/providers/endpoint-service/endpoint-service.ts